import { useAppSelector } from 'reduxTyped'
import { useShowAITab } from 'apps/aiAutomation/pages/hooks/useShowAITab'
import { Ability } from 'common/core/constants/Ability'
import { useAbility } from 'common/core/hooks/useAbility'
import {
  getHasAnyStatusFBChannel,
  getIsInstagramOnlyEnabledNoEmailNoSms,
  getIsSmsOrEmailEnabled,
  getIsTiktokOnlyEnabled,
  hasConnectedWhatsAppChannel,
} from 'common/core/selectors/channelSelectors'
import { getIsAccountAdsEnabled } from 'common/core/selectors/currentAccountSelectors'
import { getUserRole } from 'common/userRoles'
import { UserRoles } from 'common/userRoles/userRolesInterfaces'
import localStorage from 'utils/localStorage'
import { AccountFlag } from 'utils/services/featureFlagsService/constants'
import { useAccountReleaseToggle } from 'utils/services/featureFlagsService/releaseTogglesHooks'

import { NavigationRoute, NavigationRouteIds, navigationRoutes } from '../navigationRoutes'

export const useAvailableRoutes = (): NavigationRoute[] => {
  const isAiTabEnabled = useShowAITab(true)

  const enableIGRecurringNotification = useAccountReleaseToggle(
    AccountFlag.ENABLE_IG_RECURRING_NOTIFICATION,
  )
  const enableWaMarketingMtAnalytics = useAccountReleaseToggle(
    AccountFlag.ENABLE_WA_MARKETING_MT_ANALYTICS,
  )
  const analyticsUiEnabled = useAccountReleaseToggle(AccountFlag.ENABLE_ANALYTICS_UI)
  const userRole = useAppSelector(getUserRole)
  const hasWhatsAppChannel = useAppSelector(hasConnectedWhatsAppChannel)
  const isTiktokOnlyEnabled = useAppSelector(getIsTiktokOnlyEnabled)
  const isInstagramOnlyEnabled = useAppSelector(getIsInstagramOnlyEnabledNoEmailNoSms)
  const isSMSorEmailEnabled = useAppSelector(getIsSmsOrEmailEnabled)
  const hasAnyStatusFBChannel = useAppSelector(getHasAnyStatusFBChannel)
  const isAdsEnabled = useAppSelector(getIsAccountAdsEnabled)

  const analyticsAbility = useAbility(Ability.ANALYTICS)

  const hideBroadcasting =
    (!enableIGRecurringNotification && isInstagramOnlyEnabled && !isSMSorEmailEnabled) ||
    userRole === UserRoles.AGENT ||
    isTiktokOnlyEnabled

  const routesToHide: Partial<Record<NavigationRouteIds, boolean>> = {
    [NavigationRouteIds.CMS]: userRole === UserRoles.AGENT,
    [NavigationRouteIds.AI]: !isAiTabEnabled,
    [NavigationRouteIds.BROADCASTS]: hideBroadcasting,
    [NavigationRouteIds.PAID_MESSAGES]: hideBroadcasting || !hasAnyStatusFBChannel || !isAdsEnabled,
    [NavigationRouteIds.MARKETING_MESSAGE_TEMPLATES_ANALYTICS]:
      !enableWaMarketingMtAnalytics || !hasWhatsAppChannel,
    [NavigationRouteIds.ANALYTICS]:
      userRole === UserRoles.AGENT ||
      (!analyticsUiEnabled && !localStorage.getItem('enable_analytics_ui_locally')) ||
      !analyticsAbility.isEnabled,
  }

  return navigationRoutes.filter((route) => !routesToHide[route.id])
}
